module.exports = __webpack_public_path__ + "img/cloudLogo.25de26d3.png";